import "../styles/Jobs.scss";
import { content } from "../data/content";

const Jobs = () => {
  return (
    <section className="jobs">
      <h2 className="jobs__title">Experience</h2>
      <div className="jobs__grid">
        {content.jobs.map((job) => (
          <div key={job.id} id={job.id} className="jobs__card" tabIndex={0}>
            <div className="jobs__card-header">
              <h3>{job.company}</h3>
              <span className="jobs__period">{job.period}</span>
            </div>
            <h4 className="jobs__role">{job.role}</h4>

            {job.highlights && job.highlights.length > 0 && (
              <ul className="jobs__highlights">
                {job.highlights.map((highlight, i) => (
                  <li key={i}>{highlight}</li>
                ))}
              </ul>
            )}

            {job.capabilities && job.capabilities.length > 0 && (
              <div className="jobs__capabilities">
                <span className="jobs__capabilities-label">Leadership & Collaboration</span>
                <div className="jobs__technologies">
                  {job.capabilities.map((capability, i) => (
                    <span key={i} className="jobs__tech-tag jobs__tech-tag--soft">
                      {capability}
                    </span>
                  ))}
                </div>
              </div>
            )}

            <div className="jobs__technologies-group">
              <span className="jobs__technologies-label">Technologies</span>
              <div className="jobs__technologies jobs__technologies--technical">
                {job.technologies.map((tech, i) => (
                  <span key={i} className="jobs__tech-tag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Jobs;
